// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.container[data-v-785e3394] {\r\n    margin-left: 40px;\r\n    margin-right: 40px;\n}\n.text-center[data-v-785e3394] {\r\n    text-align: center;\n}\n.text-start[data-v-785e3394] {\r\n    text-align: left;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
